import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)},
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)},
  { path: 'dialogs', loadChildren: () => import('./dialogs/dialogs.module').then((m) => m.DialogsModule)},
  { path: 'tips', loadChildren: () => import('./tips/tips.module').then((m) => m.TipsModule)},
  { path: 'history', loadChildren: () => import('./history/history.module').then((m) => m.HistoryModule)},
  { path: 'profile', loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule)},
  { path: 'menu', loadChildren: () => import('./menu/menu.module').then((m) => m.MenuModule)},
  { path: 'badge', loadChildren: () => import('./badge/badge.module').then((m) => m.BadgeModule)},
  { path: 'content', loadChildren: () => import('./content/content.module').then((m) => m.ContentModule)},
  { path: 'onboarding', loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingModule)},
  { path: 'insights', loadChildren: () => import('./insights/insights.module').then((m) => m.InsightsModule)},
  { path: 'goals', loadChildren: () => import('./goals/goals.module').then((m) => m.GoalsModule)},
  { path: 'knowledge', loadChildren: () => import('./knowledge/knowledge.module').then((m) => m.KnowledgeModule)},
  { path: 'search', loadChildren: () => import('./search/search.module').then((m) => m.SearchModule)},
  { path: 'cmodule', loadChildren: () => import('./cmodule/cmodule.module').then((m) => m.CModuleModule)},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload'/*, relativeLinkResolution: 'legacy'*/ } ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
